module.exports = __webpack_public_path__ + "img/lock-blue.ff78002f.svg";